import {
  useRef,
  FC,
  InputHTMLAttributes,
  memo,
  useState,
  useEffect,
} from 'react';

import { TOTPInputSize } from '../types';

import { StyledInput } from './styles';

export interface ISingleOTPInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  focus?: boolean;
  size?: TOTPInputSize;
  hasError?: boolean;
}

export const BaseSingleOTPInput: FC<ISingleOTPInputProps> = ({
  focus,
  size = 'md',
  hasError,
  value = '',
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [focused, setFocused] = useState(false);

  const handleFocusInNative = (): void => {
    if (!inputRef.current) return;

    inputRef.current.setSelectionRange(0, 1);

    if (!focus) return;

    inputRef.current.focus();
    inputRef.current.select();
  };

  handleFocusInNative();

  useEffect(() => {
    if (!inputRef.current) return;

    if (focused) {
      handleFocusInNative();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused]);

  const handleFocus = (): void => {
    setFocused(true);
  };

  const handleBlur = (): void => {
    setFocused(false);
  };

  return (
    <StyledInput
      ref={inputRef}
      inputSize={size}
      hasError={hasError}
      onFocus={handleFocus}
      onBlur={handleBlur}
      value={value}
      autoCorrect="one-time-code"
      onSelect={handleFocusInNative}
      {...rest}
      type="text"
    />
  );
};

export const SingleOTPInput = memo(BaseSingleOTPInput);
